import React from 'react'


function BtnContact({text}) {
  return (
    <a href='https://api.whatsapp.com/send?phone=554891956772' target='__blanck' rel='noopener noreferrer'>
        <button className='btn-contact'>{text}</button>
    </a>
  )
}

export default BtnContact
